import React, { ReactNode } from 'react';
import { SelectPicker, SelectPickerProps } from 'rsuite5';

const RsPicker = ({
  align = 'left',
  placeholder = ' ',
  searchable = false,
  ...props
}: {
  align?: 'left' | 'center';
  placeholder?: ReactNode;
  [rest: string]: any;
} & SelectPickerProps<any>) => {
  return <SelectPicker className={`align-${align}`} placeholder={placeholder} searchable={searchable} {...props} />;
};

export default RsPicker;
